import React, { useState } from "react";
import { useSendEmailMutation } from "context/auth/authApiSlice.js"
import { Grid, Container, Box,Card,  Icon, CircularProgress, Typography} from '@mui/material';
import useAlert from "hooks/useAlert";
import MDAlert from "dashboard/components/MDAlert";
import MDBox from "dashboard/components/MDBox";

const initialState = {
  user: "",
  email: "",
  subject :"",
  message: "",
  error :""
};

const Contact = ({ data, parseContent }) => {
  const [{ user, email, message, subject, error }, setState] = useState(initialState);
  const {showAlerts} = useAlert();
  const [sendMail, {isLoading}] = useSendEmailMutation();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try{
      const response = await sendMail({user, email, subject, message}).unwrap();
      showAlerts({code:"success", msg : response?.message, title: "email sending " ,type : "toast"});
      clearState();
    }catch(e){
      setState((prevState) => ({ ...prevState, error: e.data?.message }));
    }
  };
  return (
    <Box id="Contact" sx={{p:{xs:1, md: 2, lg:6}}}>
      <Container  className="container" sx={{p:{xs:0}}}>
        <MDBox  className="section-title">
            <h2>{data ? data.title : "...loading"}</h2>      
        </MDBox>
        <Grid sx={{ borderRadius:({borders:{borderRadius}})=>borderRadius.xxl, overflow:"hidden"}} container >
        <Grid item sx={{display:{xs:"none", lg:"block"}}} xs={12} lg={6.5} >
            <Card sx={{height:"90vh", overflow:"hidden"}}>
              <MDBox sx={{maxHeight:"100%", width:"100%", objectFit:"cover"}} component="img" src= {`${process.env.REACT_APP_PUBLIC_URL}/img/contact/${data.photos.selectedImage}`} />
            </Card>
          </Grid>
          <Grid item xs={12} lg={6} ml={{xs:0,lg:-8}} py={{xs:1, lg:3}} >
            <Card 
            
            sx={{ borderRadius:({borders:{borderRadius}})=>borderRadius.xxl, p:{xs:.5, md:1,lg:3}, mb:3,
                backgroundColor: ({ palette: { background }, functions: { rgba } }) => rgba(background.card, 0.8),
                backdropFilter: "saturate(200%) blur(30px)",
                boxShadow: ({ boxShadows: { xxl } }) => xxl
                }} >
              <Grid className="row"  container>
                <Grid item xs={12} sx={{mt:{xs:2}}}>
                    <Typography variant="body2" sx={{display:{xs:"none", md:"flex"}}}>Veuillez remplir le formulaire ci-dessous pour nous contacter et nous vous répondrons dans les plus brefs délais.</Typography>
                </Grid>
                <Grid item xs={12}>
                <Box component="form" sx={{p:1,pt:{xs:.3, lg:2}}} name="sentMessage" validate="true" onSubmit={handleSubmit}>
                  <Grid className="row" spacing={{lg:2, xs:1}} container>
                    <Grid xs={12} md={6} item>  
                      <div className="form-group">
                        <input
                          type="text"
                          id="user"
                          name="user"
                          className="form-control"
                          placeholder="Name"
                          value={user}
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </Grid>
                    <Grid xs={12} md={6} item>  
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder="Email"
                          value={email}
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </Grid>
                    <Grid xs={12} item>  
                      <div className="form-group">
                        <input
                          type="text"
                          id="text"
                          name="subject"
                          className="form-control"
                          placeholder="Subject"
                          value={subject}
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </Grid>
                    <Grid xs={12} item> 
                      <div className="form-group">
                        <textarea
                          name="message"
                          id="message"
                          className="form-control"
                          rows="4"
                          placeholder="Message"
                          required
                          value={message}
                          onChange={handleChange}
                        ></textarea>
                      </div>
                    </Grid>
                  </Grid>
                  <Box mt={1} mb={1}>
                      {error !== ''  && <MDAlert color="error"><small style={{ fontSize:"12px",whiteSpace: "normal" }}> {error} </small></MDAlert> }
                  </Box>
                  <button style={{cursor:"pointer"}} type="submit" className="btn btn-custom btn-lg">
                    Send Message {isLoading && <CircularProgress
                      size={24}
                      sx={{
                        color: "info",
                        marginTop: '-12px',
                        marginLeft: '-12px',
                      }}
                    />}
                  </button>
                </Box>
                </Grid>
                <Grid xs={12} item><h3 style={{padding:0, margin:"15px 0"}}>Contact Info</h3></Grid>
                <Grid xs={12}  className="contact-item" item>
                  <Grid  container alignItems="center" spacing={.5}>
                    <Grid sx={{maxWidth:"25px", }} item><Icon>location_on</Icon></Grid> 
                    <Grid xs={10} item>{data ? parseContent(data.address):"...loading"}</Grid>
                  </Grid>
                </Grid>
                <Grid xs={12} md={6} className="contact-item" sx={{color: "#ccc" , fontSize : "15px", display:"flex"}} alignItems="center" item>
                    <Icon sx={{mr:1}}>phone</Icon><Box sx={{display:"inline-block", lineHeight:"normal"}}> {data ? data.phone.split(',').map( (item,i) => (
                      <React.Fragment key={`ph-${i}`}><span>{item}</span><br/></React.Fragment>
                    )) : "loading"}</Box>
                </Grid>
                <Grid xs={12} md={6} className="contact-item" sx={{color: "#ccc" , fontSize : "15px", display:"flex"}} alignItems="center" item>
                    <Icon sx={{mr:1}}>email</Icon><Box sx={{display:"inline-block", lineHeight:"normal"}}> {data ? data.email.split(',').map( (item,i) => (
                      <React.Fragment key={`ma-${i}`}><span>{item}</span><br/></React.Fragment>
                    )) : "loading"}</Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          
        </Grid>
      </Container>
    </Box>
  );
};
export default Contact;
// , background: `url(${process.env.REACT_APP_PUBLIC_URL}/img/contact/${data.photos.selectedImage}) top center no-repeat`, backgroundSize: "cover"